import { MouseEventHandler } from 'react';
import { ReactComponent as RefreshIcon } from '../../../assets/icons/refresh.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/svg/error_icon.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { NbButton } from '../button/Button';
import classes from './ErrorWidgetContent.module.scss';

interface ErrorWidgetContentProps {
  title?: string;
  buttonText?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  hideReload?: boolean;
}

export const ErrorWidgetContent = ({ title, buttonText, onClick, className, hideReload }: ErrorWidgetContentProps) => {
  const { translation } = useLocale();
  return (
    <div className={`${classes.errorWidgetContent} ${className ?? ''}`}>
      <div>
        <ErrorIcon />
      </div>
      <p className={classes.errorWidgetContentTitle}>{title ?? translation.errorWidgetContent.title}</p>
      {!hideReload && (
        <NbButton
          variant="text"
          onClick={onClick}
          startIcon={<RefreshIcon />}
          className={classes.errorWidgetContentButton}
        >
          {buttonText ?? translation.errorWidgetContent.reload}
        </NbButton>
      )}
    </div>
  );
};
